import {TabsReducer} from '../../../common/tabs/tabs.reducer';
import {IDS} from './tasks-action-id.constants';

const tabs = [
    {
        state: IDS.app_accreditation_tasks_list,
        title: 'ACCREDITATION.TASKS.LIST.TAB',
        visible: true,
        disabled: false,
        loading: false,
    },
    {
        state: IDS.app_accreditation_tasks_details,
        title: 'ACCREDITATION.TASKS.DETAILS.TAB',
        visible: true,
        disabled: true,
        loading: false
    },
];

export const tasksTabs = {
    [IDS.app_accreditation_tasks]: Object.assign(TabsReducer(), { tabs }),
}
